import { useQuery } from 'react-query';
import { getNotableClients } from '../services';

export const BASE_KEY = 'get-notable-clients';

// TODO: Use seller-phoenix once it be ready

/**
 * @param {object} data
 * @param {string|number} data.sellerId
 * @param {import('../services/getNotableClients').NotableClientData[]} data.initialData
 * @param {boolean=} data.enabled
 * @returns {import('react-query').UseQueryResult<any>}
 */
export const useNotableClientsQuery = ({ sellerId, initialData = [], enabled = false }) => {
    const data = useQuery([BASE_KEY, sellerId], () => getNotableClients(sellerId), {
        refetchInterval: 0,
        initialData,
        enabled,
    });
    return data;
};
